<fw-tooltip [title]="tooltipText">
  <div class="status-chip" test-id="status-chip-button" [class.failed]="status === statuses.Failed">
    <fw-icon class="status-chip-icon" [color]="statusColor">{{ statusIcon }}</fw-icon>
    <span class="status-chip-text">{{ title | titlecase }}</span>
  </div>
</fw-tooltip>
